$( document ).ready(function() {
  $('.accordion .toggle').click(function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.hasClass('shown')) {
      $this.removeClass('shown');
    } else {
      $this.parent().parent().find('a').removeClass('shown');
      $this.toggleClass('shown');
    }

    if ($this.next().hasClass('shown')) {
      $this.next().removeClass('shown');
      $this.next().slideUp(350);
    } else {
      $this.parent().parent().find('li .inner').removeClass('shown');
      $this.parent().parent().find('li .inner').slideUp(350);
      $this.next().toggleClass('shown');
      $this.next().slideToggle(350);
    }
  });
});


function refreshAccordion() {
  $('.accordion .toggle').click(function(e) {
    e.preventDefault();

    var $this = $(this);

    if ($this.hasClass('shown')) {
      $this.removeClass('shown');
    } else {
      $this.parent().parent().find('a').removeClass('shown');
      $this.toggleClass('shown');
    }

    if ($this.next().hasClass('shown')) {
      $this.next().removeClass('shown');
      $this.next().slideUp(350);
    } else {
      $this.parent().parent().find('li .inner').removeClass('shown');
      $this.parent().parent().find('li .inner').slideUp(350);
      $this.next().toggleClass('shown');
      $this.next().slideToggle(350);
    }
  });
}

document.addEventListener("shopify:section:load", this.refreshAccordion);
document.addEventListener("shopify:section:reorder", this.refreshAccordion);
document.addEventListener("shopify:block:select", this.refreshAccordion);
document.addEventListener("shopify:block:deselect", this.refreshAccordion);


$( document ).ready(function() {
  $('body').on('click', '.selectbox', function() {
    $('.pre-order-text').show();
  });
});

